module.exports = __webpack_public_path__ + "img/badge_18ct.f4db18e0.png";